import React, { useEffect, useState } from 'react';
import useAuth from 'hooks/useAuth';
import useThemeConfig from './useThemeConfig';
import { PageLoading } from '../PageLoading';

function ThemeWithPartner({ children }) {
    const { auth, profile } = useAuth();
    const { name, onChangeTheme } = useThemeConfig();
    //
    const [loadTheme, setLoadTheme] = useState(true);
    //

    useEffect(() => {
        const getCofigTheme = async () => {
            if (auth.status === 'FINISH' && auth.accessToken) {
                console.log('Load partner theme......');
                await onChangeTheme(auth.accessToken);

                setTimeout(() => {
                    setLoadTheme(false);
                     console.log('Load partner theme finished');
                }, 500);
            } else if (auth.status === 'FINISH') {
                console.log('Load theme......');
                await onChangeTheme(); // set 'default'
                setLoadTheme(false);
            console.log('Load theme finished');
            }
        };
        getCofigTheme();
    }, [profile.theme, JSON.stringify(auth)]);

  if (loadTheme) return <div className='loading-theme'></div>;
  
    return (
        <>
            {children}
        </>
    );
}

export default ThemeWithPartner;
